/* RESPONSIBLE TEAM: team-ai-insights */

import type { CxBenchmarkData } from 'embercom/components/reporting/bespoke/fin-performance/cx-benchmark-panel/types';

// Generated from Snowflake data for 2025-12 to 2026-03 (v2: Cockpit-aligned, per-account).
// To regenerate: run extract_benchmarks_v2.sql in Snowsight, download CSV,
// then run: python3 transform_benchmarks_v2.py <csv_file>
export const CX_BENCHMARK_DATA: CxBenchmarkData = {
  benchmarks: {
    'ecommerce:overall': {
      percentiles: {
        p5: 0.4171,
        p10: 0.4887,
        p15: 0.5371,
        p20: 0.5691,
        p25: 0.5872,
        p30: 0.6069,
        p35: 0.6265,
        p40: 0.6438,
        p45: 0.6573,
        p50: 0.6737,
        p55: 0.6852,
        p60: 0.6968,
        p65: 0.715,
        p70: 0.7276,
        p75: 0.7445,
        p80: 0.7636,
        p85: 0.7799,
        p90: 0.8031,
        p95: 0.8337,
        p100: 0.9561,
      },
      reasons: {
        answer_quality_bot_high: 0.7436,
        answer_quality_bot_low: 0.0596,
        product_feedback_positive: 0.0104,
        product_feedback_negative: 0.1415,
        policy_feedback_positive: 0.0014,
        policy_feedback_negative: 0.0828,
        user_strong_emotion_positive: 0.0101,
        user_strong_emotion_negative: 0.0816,
        user_effort_low: 0.5383,
        user_effort_high: 0.2255,
      },
      score_distribution: {
        score_1: 0.0096,
        score_2: 0.1342,
        score_3: 0.1833,
        score_4: 0.2139,
        score_5: 0.459,
      },
    },

    'education:overall': {
      percentiles: {
        p5: 0.4706,
        p10: 0.517,
        p15: 0.5596,
        p20: 0.5882,
        p25: 0.611,
        p30: 0.6325,
        p35: 0.6539,
        p40: 0.6692,
        p45: 0.6825,
        p50: 0.7009,
        p55: 0.7179,
        p60: 0.7368,
        p65: 0.7555,
        p70: 0.7731,
        p75: 0.7833,
        p80: 0.7967,
        p85: 0.815,
        p90: 0.8327,
        p95: 0.864,
        p100: 0.9501,
      },
      reasons: {
        answer_quality_bot_high: 0.7502,
        answer_quality_bot_low: 0.0563,
        product_feedback_positive: 0.009,
        product_feedback_negative: 0.1225,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0575,
        user_strong_emotion_positive: 0.0102,
        user_strong_emotion_negative: 0.0614,
        user_effort_low: 0.5034,
        user_effort_high: 0.258,
      },
      score_distribution: {
        score_1: 0.0054,
        score_2: 0.1162,
        score_3: 0.1622,
        score_4: 0.2119,
        score_5: 0.5043,
      },
    },

    'fintech:overall': {
      percentiles: {
        p5: 0.3898,
        p10: 0.4548,
        p15: 0.4995,
        p20: 0.5317,
        p25: 0.5572,
        p30: 0.58,
        p35: 0.5998,
        p40: 0.6195,
        p45: 0.6405,
        p50: 0.6554,
        p55: 0.6729,
        p60: 0.6911,
        p65: 0.7098,
        p70: 0.7276,
        p75: 0.748,
        p80: 0.7685,
        p85: 0.798,
        p90: 0.8216,
        p95: 0.8537,
        p100: 0.9696,
      },
      reasons: {
        answer_quality_bot_high: 0.7327,
        answer_quality_bot_low: 0.062,
        product_feedback_positive: 0.0054,
        product_feedback_negative: 0.1049,
        policy_feedback_positive: 0.0004,
        policy_feedback_negative: 0.0844,
        user_strong_emotion_positive: 0.0061,
        user_strong_emotion_negative: 0.0742,
        user_effort_low: 0.4819,
        user_effort_high: 0.2696,
      },
      score_distribution: {
        score_1: 0.0077,
        score_2: 0.1385,
        score_3: 0.1902,
        score_4: 0.2146,
        score_5: 0.4491,
      },
    },

    'gaming_and_gambling:overall': {
      percentiles: {
        p5: 0.3058,
        p10: 0.3461,
        p15: 0.3753,
        p20: 0.4128,
        p25: 0.4477,
        p30: 0.4608,
        p35: 0.4848,
        p40: 0.5022,
        p45: 0.5178,
        p50: 0.5259,
        p55: 0.5448,
        p60: 0.56,
        p65: 0.5812,
        p70: 0.5987,
        p75: 0.6159,
        p80: 0.6349,
        p85: 0.6607,
        p90: 0.7055,
        p95: 0.7488,
        p100: 0.8755,
      },
      reasons: {
        answer_quality_bot_high: 0.6236,
        answer_quality_bot_low: 0.0853,
        product_feedback_positive: 0.0029,
        product_feedback_negative: 0.1482,
        policy_feedback_positive: 0.0006,
        policy_feedback_negative: 0.1624,
        user_strong_emotion_positive: 0.0062,
        user_strong_emotion_negative: 0.1472,
        user_effort_low: 0.4111,
        user_effort_high: 0.2976,
      },
      score_distribution: {
        score_1: 0.023,
        score_2: 0.2028,
        score_3: 0.2339,
        score_4: 0.1983,
        score_5: 0.3419,
      },
    },

    'healthcare:overall': {
      percentiles: {
        p5: 0.4352,
        p10: 0.4851,
        p15: 0.5329,
        p20: 0.5606,
        p25: 0.5901,
        p30: 0.6138,
        p35: 0.6329,
        p40: 0.6526,
        p45: 0.6699,
        p50: 0.6863,
        p55: 0.6992,
        p60: 0.7138,
        p65: 0.7296,
        p70: 0.7453,
        p75: 0.7609,
        p80: 0.7836,
        p85: 0.8043,
        p90: 0.8263,
        p95: 0.8706,
        p100: 0.9672,
      },
      reasons: {
        answer_quality_bot_high: 0.7417,
        answer_quality_bot_low: 0.0614,
        product_feedback_positive: 0.005,
        product_feedback_negative: 0.1096,
        policy_feedback_positive: 0.0002,
        policy_feedback_negative: 0.0561,
        user_strong_emotion_positive: 0.0072,
        user_strong_emotion_negative: 0.0673,
        user_effort_low: 0.5478,
        user_effort_high: 0.2337,
      },
      score_distribution: {
        score_1: 0.0059,
        score_2: 0.1263,
        score_3: 0.1744,
        score_4: 0.2095,
        score_5: 0.4839,
      },
    },

    'hospitality_and_tourism:overall': {
      percentiles: {
        p5: 0.5013,
        p10: 0.5503,
        p15: 0.5914,
        p20: 0.6154,
        p25: 0.6244,
        p30: 0.6436,
        p35: 0.6701,
        p40: 0.6838,
        p45: 0.6909,
        p50: 0.702,
        p55: 0.7233,
        p60: 0.7414,
        p65: 0.759,
        p70: 0.7749,
        p75: 0.7948,
        p80: 0.8135,
        p85: 0.8329,
        p90: 0.8818,
        p95: 0.9112,
        p100: 0.9314,
      },
      reasons: {
        answer_quality_bot_high: 0.7718,
        answer_quality_bot_low: 0.0478,
        product_feedback_positive: 0.0058,
        product_feedback_negative: 0.0896,
        policy_feedback_positive: 0.0014,
        policy_feedback_negative: 0.0633,
        user_strong_emotion_positive: 0.0076,
        user_strong_emotion_negative: 0.0488,
        user_effort_low: 0.5582,
        user_effort_high: 0.2071,
      },
      score_distribution: {
        score_1: 0.0045,
        score_2: 0.1031,
        score_3: 0.1764,
        score_4: 0.2208,
        score_5: 0.4952,
      },
    },

    'manufacturing:overall': {
      percentiles: {
        p5: 0.4134,
        p10: 0.4927,
        p15: 0.5575,
        p20: 0.5899,
        p25: 0.6088,
        p30: 0.6359,
        p35: 0.659,
        p40: 0.6751,
        p45: 0.6974,
        p50: 0.7261,
        p55: 0.7363,
        p60: 0.7493,
        p65: 0.7574,
        p70: 0.7699,
        p75: 0.7803,
        p80: 0.7932,
        p85: 0.8124,
        p90: 0.8312,
        p95: 0.8559,
        p100: 0.9001,
      },
      reasons: {
        answer_quality_bot_high: 0.8231,
        answer_quality_bot_low: 0.0555,
        product_feedback_positive: 0.0128,
        product_feedback_negative: 0.092,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0447,
        user_strong_emotion_positive: 0.0086,
        user_strong_emotion_negative: 0.0551,
        user_effort_low: 0.5631,
        user_effort_high: 0.167,
      },
      score_distribution: {
        score_1: 0.007,
        score_2: 0.1022,
        score_3: 0.1744,
        score_4: 0.1971,
        score_5: 0.5193,
      },
    },

    'media_and_entertainment:overall': {
      percentiles: {
        p5: 0.4216,
        p10: 0.4717,
        p15: 0.4954,
        p20: 0.53,
        p25: 0.548,
        p30: 0.5557,
        p35: 0.5673,
        p40: 0.5848,
        p45: 0.6088,
        p50: 0.6246,
        p55: 0.641,
        p60: 0.6565,
        p65: 0.6796,
        p70: 0.7024,
        p75: 0.7223,
        p80: 0.752,
        p85: 0.7746,
        p90: 0.7975,
        p95: 0.8235,
        p100: 0.8603,
      },
      reasons: {
        answer_quality_bot_high: 0.659,
        answer_quality_bot_low: 0.0672,
        product_feedback_positive: 0.005,
        product_feedback_negative: 0.1308,
        policy_feedback_positive: 0.0006,
        policy_feedback_negative: 0.0912,
        user_strong_emotion_positive: 0.0096,
        user_strong_emotion_negative: 0.1188,
        user_effort_low: 0.4217,
        user_effort_high: 0.3036,
      },
      score_distribution: {
        score_1: 0.0127,
        score_2: 0.1723,
        score_3: 0.1775,
        score_4: 0.2197,
        score_5: 0.4179,
      },
    },

    'other:overall': {
      percentiles: {
        p5: 0.421,
        p10: 0.4728,
        p15: 0.5194,
        p20: 0.5408,
        p25: 0.5699,
        p30: 0.5898,
        p35: 0.6181,
        p40: 0.6433,
        p45: 0.6618,
        p50: 0.6766,
        p55: 0.695,
        p60: 0.7182,
        p65: 0.7352,
        p70: 0.7515,
        p75: 0.7724,
        p80: 0.7911,
        p85: 0.8121,
        p90: 0.8475,
        p95: 0.8793,
        p100: 0.9481,
      },
      reasons: {
        answer_quality_bot_high: 0.7516,
        answer_quality_bot_low: 0.0594,
        product_feedback_positive: 0.008,
        product_feedback_negative: 0.1264,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0597,
        user_strong_emotion_positive: 0.0074,
        user_strong_emotion_negative: 0.0709,
        user_effort_low: 0.5079,
        user_effort_high: 0.2441,
      },
      score_distribution: {
        score_1: 0.0082,
        score_2: 0.1316,
        score_3: 0.1755,
        score_4: 0.2088,
        score_5: 0.4759,
      },
    },

    'overall:overall': {
      percentiles: {
        p5: 0.42,
        p10: 0.4821,
        p15: 0.5218,
        p20: 0.5521,
        p25: 0.5765,
        p30: 0.6005,
        p35: 0.62,
        p40: 0.639,
        p45: 0.6564,
        p50: 0.6739,
        p55: 0.6899,
        p60: 0.7057,
        p65: 0.7225,
        p70: 0.7388,
        p75: 0.7571,
        p80: 0.7757,
        p85: 0.7966,
        p90: 0.8199,
        p95: 0.8567,
        p100: 0.9905,
      },
      reasons: {
        answer_quality_bot_high: 0.7341,
        answer_quality_bot_low: 0.0617,
        product_feedback_positive: 0.0067,
        product_feedback_negative: 0.1361,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0514,
        user_strong_emotion_positive: 0.0066,
        user_strong_emotion_negative: 0.0654,
        user_effort_low: 0.4695,
        user_effort_high: 0.2784,
      },
      score_distribution: {
        score_1: 0.0068,
        score_2: 0.132,
        score_3: 0.1808,
        score_4: 0.2196,
        score_5: 0.4608,
      },
    },

    'professional_services:overall': {
      percentiles: {
        p5: 0.4154,
        p10: 0.4842,
        p15: 0.516,
        p20: 0.5354,
        p25: 0.5572,
        p30: 0.5812,
        p35: 0.6033,
        p40: 0.6268,
        p45: 0.652,
        p50: 0.673,
        p55: 0.692,
        p60: 0.7102,
        p65: 0.7339,
        p70: 0.7511,
        p75: 0.7647,
        p80: 0.7917,
        p85: 0.8129,
        p90: 0.8395,
        p95: 0.8743,
        p100: 0.943,
      },
      reasons: {
        answer_quality_bot_high: 0.7562,
        answer_quality_bot_low: 0.0572,
        product_feedback_positive: 0.0069,
        product_feedback_negative: 0.1098,
        policy_feedback_positive: 0.0009,
        policy_feedback_negative: 0.0575,
        user_strong_emotion_positive: 0.0072,
        user_strong_emotion_negative: 0.0667,
        user_effort_low: 0.5185,
        user_effort_high: 0.249,
      },
      score_distribution: {
        score_1: 0.0059,
        score_2: 0.1305,
        score_3: 0.1895,
        score_4: 0.2152,
        score_5: 0.459,
      },
    },

    'real_estate:overall': {
      percentiles: {
        p5: 0.4637,
        p10: 0.4906,
        p15: 0.5217,
        p20: 0.5443,
        p25: 0.5732,
        p30: 0.5981,
        p35: 0.6188,
        p40: 0.6344,
        p45: 0.6538,
        p50: 0.6626,
        p55: 0.6765,
        p60: 0.6889,
        p65: 0.7002,
        p70: 0.7156,
        p75: 0.7374,
        p80: 0.7514,
        p85: 0.7745,
        p90: 0.7883,
        p95: 0.8188,
        p100: 0.8901,
      },
      reasons: {
        answer_quality_bot_high: 0.7263,
        answer_quality_bot_low: 0.0684,
        product_feedback_positive: 0.0059,
        product_feedback_negative: 0.1369,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0507,
        user_strong_emotion_positive: 0.0051,
        user_strong_emotion_negative: 0.0607,
        user_effort_low: 0.4804,
        user_effort_high: 0.2897,
      },
      score_distribution: {
        score_1: 0.007,
        score_2: 0.1435,
        score_3: 0.1784,
        score_4: 0.2167,
        score_5: 0.4545,
      },
    },

    'software_and_technology:overall': {
      percentiles: {
        p5: 0.4393,
        p10: 0.5009,
        p15: 0.5395,
        p20: 0.5681,
        p25: 0.5914,
        p30: 0.6135,
        p35: 0.6332,
        p40: 0.6503,
        p45: 0.668,
        p50: 0.6836,
        p55: 0.6982,
        p60: 0.7126,
        p65: 0.7274,
        p70: 0.7428,
        p75: 0.7595,
        p80: 0.7776,
        p85: 0.7973,
        p90: 0.8193,
        p95: 0.8535,
        p100: 0.9555,
      },
      reasons: {
        answer_quality_bot_high: 0.7318,
        answer_quality_bot_low: 0.0615,
        product_feedback_positive: 0.007,
        product_feedback_negative: 0.1567,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0311,
        user_strong_emotion_positive: 0.0059,
        user_strong_emotion_negative: 0.0582,
        user_effort_low: 0.4346,
        user_effort_high: 0.3024,
      },
      score_distribution: {
        score_1: 0.0059,
        score_2: 0.1282,
        score_3: 0.1764,
        score_4: 0.2282,
        score_5: 0.4614,
      },
    },

    'transportation:overall': {
      percentiles: {
        p5: 0.3905,
        p10: 0.446,
        p15: 0.4874,
        p20: 0.5216,
        p25: 0.5429,
        p30: 0.5648,
        p35: 0.5831,
        p40: 0.5963,
        p45: 0.6075,
        p50: 0.6257,
        p55: 0.6407,
        p60: 0.6579,
        p65: 0.6698,
        p70: 0.6913,
        p75: 0.7112,
        p80: 0.7319,
        p85: 0.7486,
        p90: 0.7661,
        p95: 0.7949,
        p100: 0.8952,
      },
      reasons: {
        answer_quality_bot_high: 0.6968,
        answer_quality_bot_low: 0.0742,
        product_feedback_positive: 0.0044,
        product_feedback_negative: 0.0909,
        policy_feedback_positive: 0.0002,
        policy_feedback_negative: 0.0891,
        user_strong_emotion_positive: 0.0057,
        user_strong_emotion_negative: 0.0718,
        user_effort_low: 0.4912,
        user_effort_high: 0.2641,
      },
      score_distribution: {
        score_1: 0.0074,
        score_2: 0.1552,
        score_3: 0.2073,
        score_4: 0.2193,
        score_5: 0.4109,
      },
    },
  },
};
